import { render, staticRenderFns } from "./AiVoiceRealtimeTranslate.vue?vue&type=template&id=3a406b9a&scoped=true"
import script from "./AiVoiceRealtimeTranslate.vue?vue&type=script&lang=js"
export * from "./AiVoiceRealtimeTranslate.vue?vue&type=script&lang=js"
import style0 from "./AiVoiceRealtimeTranslate.vue?vue&type=style&index=0&id=3a406b9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a406b9a",
  null
  
)

export default component.exports